import PropTypes from 'prop-types';
import React from 'react';
import {Typography} from '@mui/material';

import PropertySelector from './PropertySelector.jsx';
import {Accordion, AccordionDetails, AccordionSummary} from './Common.jsx';
import {getUniqueProperties} from './util.js';

const FeaturePropsForm = ({
  features = [],
  featureProperties = {
    id: '',
    title: '',
    description: '',
  },
  setFeatureProperties,
  ...props
}) => {
  const uniqueProps = getUniqueProperties(features);

  return (
    <Accordion {...props}>
      <AccordionSummary>
        <Typography variant="subtitle2" display="block">
          Choose features naming properties
          <Typography component="span" variant="body2" color="textSecondary">
            &nbsp;(Optional)
          </Typography>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <PropertySelector
          label="Id"
          properties={uniqueProps}
          value={featureProperties.id}
          onChange={property =>
            setFeatureProperties(props => ({...props, id: property}))
          }
          fullWidth
          margin="dense"
        />
        <PropertySelector
          label="Title"
          properties={uniqueProps}
          value={featureProperties.title}
          onChange={property =>
            setFeatureProperties(props => ({...props, title: property}))
          }
          fullWidth
          margin="dense"
        />
        <PropertySelector
          label="Description"
          properties={uniqueProps}
          value={featureProperties.description}
          onChange={property =>
            setFeatureProperties(props => ({...props, description: property}))
          }
          fullWidth
          margin="dense"
        />
      </AccordionDetails>
    </Accordion>
  );
};

FeaturePropsForm.propTypes = {
  features: PropTypes.array,
  featureProperties: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  setFeatureProperties: PropTypes.func,
};

export default FeaturePropsForm;
